(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["free-of-list"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-sk-exclusions-link]');
  if (!link) return;
  const disclosure = document.getElementById(link.hash.slice(1));
  if (!(disclosure instanceof HTMLDetailsElement)) return;
  event.preventDefault();
  disclosure.open = true;
  disclosure.querySelector('summary')?.focus({ preventScroll: true });
  disclosure.scrollIntoView({
    behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
    block: 'start'
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scent-cards"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('skn-card-ribbon')){
customElements.define('skn-card-ribbon',class extends HTMLElement{
connectedCallback(){
this.motion=matchMedia('(prefers-reduced-motion: reduce)');
this.update=()=>{
this.frame=0;
if(this.hasAttribute('data-home-swatch')){
const stage=this.parentElement.getBoundingClientRect();
this.style.setProperty('--ribbon-center-offset',(document.documentElement.clientWidth/2-stage.left-stage.width/2)+'px');
}
if(this.motion.matches){this.style.transform='';return;}
const box=this.closest('.scent-card').getBoundingClientRect();
const progress=Math.max(0,Math.min(1,(innerHeight-box.top)/(innerHeight+box.height)));
const reverse=this.classList.contains('skn-card-ribbon--reverse');
const distance=this.hasAttribute('data-home-swatch')?Math.min(box.width*.24,90):Math.min(box.width*.08,28);
const x=(progress-.5)*distance*(reverse?-1:1);
const y=(progress-.5)*distance*.65;
this.style.transform='translate3d('+x+'px,'+y+'px,0) rotate('+(reverse?12:-12)+'deg)';
};
this.schedule=()=>{if(!this.frame)this.frame=requestAnimationFrame(this.update);};
this.observer=new IntersectionObserver(entries=>{
window.removeEventListener('scroll',this.schedule);
if(entries.some(e=>e.isIntersecting)){window.addEventListener('scroll',this.schedule,{passive:true});this.schedule();}
});
this.observer.observe(this);
window.addEventListener('resize',this.schedule,{passive:true});
this.motion.addEventListener('change',this.schedule);
this.update();
}
disconnectedCallback(){this.observer?.disconnect();window.removeEventListener('scroll',this.schedule);window.removeEventListener('resize',this.schedule);this.motion?.removeEventListener('change',this.schedule);cancelAnimationFrame(this.frame);}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skn-about-story"] && !Shopify.designMode) return;
  try {
    
const initStoryMotion=()=>{
 if(window.matchMedia('(prefers-reduced-motion: reduce)').matches||!('IntersectionObserver' in window))return;
 const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
  if(!entry.isIntersecting)return;
  entry.target.animate([{opacity:.45,transform:entry.target.classList.contains('skn-story__hero-media')?'translateX(-30px)':'translateY(18px)'},{opacity:1,transform:'translate(0,0)'}],{duration:550,easing:'cubic-bezier(.2,.7,.2,1)',fill:'none'});
  observer.unobserve(entry.target);
 }),{threshold:.08});
 document.querySelectorAll('.skn-story__origin,.skn-story__person,.skn-story__value,.skn-story__community,.skn-story__press-link,.skn-story__promise-grid>article').forEach(el=>{if(!el.dataset.revealReady){el.dataset.revealReady='true';observer.observe(el);}});
};
initStoryMotion();
document.addEventListener('shopify:section:load',initStoryMotion);

const initMissionQuote=()=>{
 if(window.matchMedia('(prefers-reduced-motion: reduce)').matches||!('IntersectionObserver' in window))return;
 document.querySelectorAll('.skn-story__mission').forEach(quote=>{
  if(quote.dataset.quoteReady)return;
  quote.dataset.quoteReady='true';
  const observer=new IntersectionObserver(entries=>{
   if(!entries.some(entry=>entry.isIntersecting))return;
   quote.querySelectorAll('.skn-story__quote-phrase').forEach((line,i)=>{
    line.animate([{opacity:0,transform:'translateY(16px)'},{opacity:1,transform:'translateY(0)'}],{duration:1000,delay:i*100,easing:'cubic-bezier(.16,1,.3,1)',fill:'backwards'});
   });
   observer.disconnect();
  },{threshold:.15});
  observer.observe(quote);
 });
};
initMissionQuote();
document.addEventListener('shopify:section:load',initMissionQuote);

const initFounderCollage=()=>{
 const motion=window.matchMedia('(prefers-reduced-motion: reduce)');
 if(motion.matches||!('IntersectionObserver' in window)||!Element.prototype.animate)return;
 document.querySelectorAll('.skn-story__hero-media').forEach(media=>{
  if(media.dataset.collageReady)return;
  media.dataset.collageReady='true';
  const img=media.querySelector('img');if(!img)return;
  const frames=Array.from({length:61},(_,step)=>{
   const t=step/60,remaining=step===60?0:Math.pow(2,-10*t);
   return {offset:t,opacity:1-remaining,transform:'translate('+(120*remaining)+'px,'+(50*remaining)+'px) rotate('+(-10*remaining)+'deg)'};
  });
  const animation=img.animate(frames,{duration:1800,easing:'linear',fill:'both'});
  animation.pause();animation.currentTime=0;
  animation.onfinish=()=>animation.cancel();
  const observer=new IntersectionObserver(entries=>{
   if(!entries.some(entry=>entry.isIntersecting))return;
   const play=()=>{if(motion.matches){animation.cancel();return;}animation.play();};
   if(img.complete)play();else img.addEventListener('load',play,{once:true});
   observer.disconnect();
  },{threshold:0});
  observer.observe(media);
  motion.addEventListener('change',event=>{if(event.matches){observer.disconnect();animation.cancel();}},{once:true});
 });
};
initFounderCollage();
document.addEventListener('shopify:section:load',initFounderCollage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skn-community-editorial"] && !Shopify.designMode) return;
  try {
    
function revealCommunity(){
 if(matchMedia('(prefers-reduced-motion: reduce)').matches||!('IntersectionObserver' in window))return;
 const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.animate([{opacity:.55,transform:'translateY(16px)'},{opacity:1,transform:'translateY(0)'}],{duration:800,easing:'cubic-bezier(.16,1,.3,1)'});observer.unobserve(entry.target);}}),{threshold:.08});
 document.querySelectorAll('.skn-community__card,.skn-community__jump a').forEach(el=>{if(!el.dataset.communityReveal){el.dataset.communityReveal='true';observer.observe(el);}});
}revealCommunity();document.addEventListener('shopify:section:load',revealCommunity);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skn-community-redirect"]) return;
  try {
    
if(location.pathname==='/pages/our-story'&&new URLSearchParams(location.search).get('view')==='community'){
  const destination=new URL(location.href);
  destination.searchParams.delete('view');
  destination.hash=location.hash==='#recognition'?'recognition':'community';
  location.replace(destination.href);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skn-ingredient-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('skn-ingredient-scene')) {
  customElements.define('skn-ingredient-scene', class extends HTMLElement {
    connectedCallback() {
      this.layers = [...this.querySelectorAll('[data-ingredient-layer]')];
      this.pouch = this.querySelector('[data-ingredient-pouch]');
      this.collage = this.querySelector('[data-ingredient-collage]');
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.frame = 0;
      this.schedule = () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.paint(); });
      };
      this.configure = () => {
        this.toggleAttribute('data-motion', !this.motion.matches);
        if (this.motion.matches) {
          [...this.layers, this.pouch, this.collage].filter(Boolean).forEach(layer => layer.style.removeProperty('transform'));
        } else this.schedule();
      };
      this.motion.addEventListener('change', this.configure);
      window.addEventListener('scroll', this.schedule, { passive: true });
      window.addEventListener('resize', this.schedule, { passive: true });
      this.configure();
    }
    paint() {
      if (this.motion.matches || !this.isConnected) return;
      const rect = this.getBoundingClientRect();
      const viewport = window.innerHeight;
      if (rect.bottom < 0 || rect.top > viewport) return;
      const stage = this.querySelector('.skn-ingredient-scene__stage');
      const distance = Math.max(1, rect.height - stage.offsetHeight + viewport * .6);
      const progress = Math.max(0, Math.min(1, (viewport * .65 - rect.top) / distance));
      const spread = progress * progress * (3 - 2 * progress);
      const positions = [[-115,-60,-18],[95,-80,14],[-110,38,-12],[115,35,20],[-55,90,-8],[50,95,12]];
      this.layers.forEach((layer, index) => {
        const [x,y,r] = positions[index % positions.length];
        const expansion = .12 + spread * .88;
        layer.style.transform = 'translate(' + (-50 + x * expansion) + '%, ' + (-50 + y * expansion + (1-spread)*28) + '%) rotate(' + (r * spread) + 'deg) scale(' + (.65 + spread * .35) + ')';
      });
      if (this.pouch) this.pouch.style.transform = 'translate(-50%, ' + (-35 - spread * 15) + '%) scale(' + (.86 + spread * .14) + ')';
      if (this.collage) this.collage.style.transform = 'translateY(' + ((1-spread)*15) + '%) scale(' + (.55+spread*.45) + ')';
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.schedule);
      window.removeEventListener('resize', this.schedule);
      this.motion?.removeEventListener('change', this.configure);
      if (this.frame) cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skn-resource-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('skn-resource-story')) {
customElements.define('skn-resource-story', class extends HTMLElement {
connectedCallback() {
if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
this.setAttribute('data-scroll-ready','');
this.revealObserver = new IntersectionObserver(entries => {
entries.forEach(entry => {
if (entry.isIntersecting) {
entry.target.classList.add('is-visible');
this.revealObserver.unobserve(entry.target);
}
});
}, {threshold:0.08});
this.querySelectorAll('.skn-resource-card').forEach(card => this.revealObserver.observe(card));
}

this.onClick = event => {
const button = event.target.closest('.skn-resource-card__photo');
if (!button) return;
const card = button.closest('.skn-resource-card');
const open = !card.hasAttribute('data-open');
card.toggleAttribute('data-open', open);
button.setAttribute('aria-expanded', String(open));
if (!open) button.blur();
};
this.onKey = event => {
if (event.key !== 'Escape') return;
const card = event.target.closest('.skn-resource-card');
if (!card) return;
card.removeAttribute('data-open');
card.querySelector('button').setAttribute('aria-expanded','false');
card.querySelector('button').blur();
};
this.addEventListener('click',this.onClick);
this.addEventListener('keydown',this.onKey);
}
disconnectedCallback(){this.revealObserver?.disconnect();this.removeEventListener('click',this.onClick);this.removeEventListener('keydown',this.onKey);}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skn-without-marquee"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function setupWithoutMarquees() {
      document.querySelectorAll('[data-skn-without-marquee]').forEach(root => {
        if (root.hasAttribute('data-ready')) return;
        const toggle = root.querySelector('.skn-without-marquee__toggle');
        toggle.hidden = false;
        root.setAttribute('data-ready', '');
        toggle.addEventListener('click', () => {
          const paused = root.toggleAttribute('data-paused');
          toggle.setAttribute('aria-pressed', String(paused));
          toggle.setAttribute('aria-label', paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
        });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupWithoutMarquees);
    else setupWithoutMarquees();
    document.addEventListener('shopify:section:load', setupWithoutMarquees);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sunkids-faq-page"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.sf-page').forEach(function(root){var nav=root.querySelector('.sf-nav');var buttons=Array.from(root.querySelectorAll('[data-faq-select]'));var panels=Array.from(root.querySelectorAll('[data-faq-panel]'));if(!nav||!buttons.length)return;function select(index){buttons.forEach(function(b,i){b.setAttribute('aria-pressed',String(i===index))});panels.forEach(function(p,i){p.hidden=i!==index})}buttons.forEach(function(b,i){b.addEventListener('click',function(){select(i)})});select(0);nav.hidden=false;root.classList.add('sf-tabs-ready')});

const sfFaqPalette = ['#ffd1dc', '#a7c7e7', '#fdbb9d'];
const sfFaqPrevious = new WeakMap();
let sfFaqLastColor = null;
let sfFaqTouchCard = null;
function sfRotateFaqColor(card) {
  const previous = sfFaqPrevious.get(card);
  const choices = sfFaqPalette.filter(color => color !== previous && color !== sfFaqLastColor);
  const color = choices[Math.floor(Math.random() * choices.length)];
  card.style.setProperty('--skn-faq-hover-color', color);
  sfFaqPrevious.set(card, color);
  sfFaqLastColor = color;
}
function sfFaqCardFor(event) {
  return event.target instanceof Element ? event.target.closest('.sf-page .sf-question') : null;
}
document.addEventListener('pointerover', event => {
  if (event.pointerType === 'touch') return;
  const card = sfFaqCardFor(event);
  if (!card || (event.relatedTarget instanceof Node && card.contains(event.relatedTarget))) return;
  sfRotateFaqColor(card);
}, { passive: true });
document.addEventListener('focusin', event => {
  const card = sfFaqCardFor(event);
  if (!card || (event.relatedTarget instanceof Node && card.contains(event.relatedTarget))) return;
  sfRotateFaqColor(card);
});
document.addEventListener('pointerdown', event => {
  if (event.pointerType !== 'touch') return;
  const card = sfFaqCardFor(event);
  if (sfFaqTouchCard) sfFaqTouchCard.classList.remove('sf-touch-active');
  sfFaqTouchCard = card;
  if (!card) return;
  sfRotateFaqColor(card);
  card.classList.add('sf-touch-active');
}, { passive: true });


  } catch(e) { console.error(e); }
})();
})();
